import React, { Component } from 'react'
import { Modal, Button, Input, message, Form } from 'antd';
import { qualified } from '@/request/api'

const { TextArea } = Input;
class UnqualifiedModal extends Component {
  state = {
    reviewResults: "",
    reviewJournal: ""
  }

  handleSubmitApply = () => {
    const { rowData } = this.props
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let requestModel = {
          QUALITY_RESULTS: values.reviewResults, //质控结果
          QUALITY_LOG: values.reviewJournal,     //质控日志
          ISQUALIFIED: 0, //是否合格(0：不合格，1：合格)
          QUALITY_UID: rowData.QUALITY_UID
        }
        qualified(requestModel).then((res) => {
          if (res && res.Status === 1) {
            message.success("操作成功")
            this.props.onRef(false);
            this.props.handleHospitalSubmit()
          } else {
            message.error("操作失败")
          }
        })
      }
    })
  }

  handleReviewResults = (e) => {
    this.setState({
      reviewResults: e.target.value
    })
  }

  handleReviewJournal = (e) => {
    this.setState({
      reviewJournal: e.target.value
    })
  }

  handleCloseApplyModal = () => {
    this.props.onRef(false);
  }

  render() {
    const { visible } = this.props
    const { getFieldDecorator } = this.props.form;
    const layout = { labelCol: { span: 6 }, wrapperCol: { span: 14 }, };

    return (
      <Modal
        className="consulationH"
        width={440}
        title="编辑不合格"
        visible={visible}
        footer={[
          <Button key="save" type="primary" onClick={this.handleSubmitApply}>
            确定
          </Button>,
          <Button key="exit" type="primary" onClick={this.handleCloseApplyModal}>
            取消
          </Button>
        ]}
        onCancel={this.handleCloseApplyModal}  // 右上角的关闭按钮
      >
        <Form {...layout}>
          <Form.Item label="质控结果">
            {getFieldDecorator('reviewResults', {
              rules: [{ required: true, message: '质控结果不能为空!' }],
            })(<TextArea />)}
          </Form.Item>

          <Form.Item label="质控日志">
            {getFieldDecorator('reviewJournal', {
              rules: [{ required: true, message: '质控日志不能为空!' }],
            })(<TextArea />)}
          </Form.Item>
        </Form>
      </Modal>
    )
  }
}

export default Form.create({})(UnqualifiedModal)